import { render, staticRenderFns } from "./VuesticSidebar.vue?vue&type=template&id=c40fbbe8"
import script from "./VuesticSidebar.vue?vue&type=script&lang=js"
export * from "./VuesticSidebar.vue?vue&type=script&lang=js"
import style0 from "./VuesticSidebar.vue?vue&type=style&index=0&id=c40fbbe8&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c40fbbe8')) {
      api.createRecord('c40fbbe8', component.options)
    } else {
      api.reload('c40fbbe8', component.options)
    }
    module.hot.accept("./VuesticSidebar.vue?vue&type=template&id=c40fbbe8", function () {
      api.rerender('c40fbbe8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-sidebar/VuesticSidebar.vue"
export default component.exports